import {connect} from 'react-redux';
import {checkPermissions} from './AccessUtils';

const AccessControl = ({
  userPermissions,
  allowedPermissions,
  clientId,
  children,
  renderNoAccess,
  clients,
  admin,
}) => {
  const permitted = checkPermissions(admin, userPermissions, allowedPermissions, clients, clientId);
  if (permitted) {
    return children;
  }
  return renderNoAccess();
};

AccessControl.defaultProps = {
  allowedPermissions: [],
  userPermissions: [],
  admin: false,
  clients: [],
  renderNoAccess: () => '',
};

function mapStateToProps(state) {
  const user = state.Auth.user;
  return {
    clients: user.clients,
    admin: user.isSuperAdmin,
    userPermissions: user.permissions,
  };
};

export default connect(mapStateToProps)(AccessControl);
